import { parseUrlDomain } from 'shared/utils'
import { PostPreviewDefaultHeader } from './PostPreviewDefaultHeader'
import styles from './TwitterPostPreview.pcss'
import { ImagesPreviewGrid } from './ImagesPreviewGrid'
import { mdiCommentOutline, mdiRepeat, mdiHeartOutline, mdiDotsHorizontal } from '@mdi/js'
import Icon from '@mdi/react'
import PostPreviewText from './PostPreviewText'
import { PostPreviewVideoPlayer } from './PostPreviewVideoPlayer'

const TRUNCATE_MAX_LINES = 7
const EXPAND_TEXT_LABEL = 'Show More'
const COLLAPSE_TEXT_LABEL = 'Show Less'

interface BlueskyPostPreviewProps {
  profile?: { name: string, image: string }
  status?: string
  empty?: boolean
  emptyText?: boolean
  featuredImageUrl?: string
  imageUrls?: string[]
  videoUrl?: string
  commentsCount?: number
  article?: {
    url: string
    title: string
    description?: string
    isVideo?: boolean
  }
}

export function BlueskyPostPreview(props: BlueskyPostPreviewProps) {
  const { commentsCount, videoUrl } = props
  const withContent = props.article || props.featuredImageUrl || videoUrl
  const additionalImages = props.imageUrls ? props.imageUrls.filter(url => url !== props.featuredImageUrl) : []
  const isEmpty = props.empty
    || props.emptyText
    || (!props.status && !props.article && !props.featuredImageUrl && !videoUrl)

  const articleBlock = props.article && !props.article?.isVideo && (
    <div className={styles['article-box']}>
      <div className={`${styles.title} text-ellipsis`}>{props.article.title}</div>
      {props.article.description && (
        <div className={`${styles.description} text-ellipsis`}>{props.article.description}</div>
      )}
      <div className={styles.link}>{parseUrlDomain(props.article.url)}</div>
    </div>
  )

  return (
    <article className={`${styles.post} ${isEmpty ? styles.empty : ''}`}>
      <PostPreviewDefaultHeader profile={props.profile} />
      <main className={styles.main}>
        {props.emptyText && (
          <div className={styles['empty-text']}>
            <div></div>
            <div></div>
            <div></div>
          </div>
        )}
        {props.status && (
          <PostPreviewText
            text={props.status}
            maxLinesDefault={TRUNCATE_MAX_LINES}
            collapseLabel={COLLAPSE_TEXT_LABEL}
            expandLabel={EXPAND_TEXT_LABEL}
            className={`${styles.status} ${styles['status-tw']}`}
          />
        )}
        {isEmpty && !props.emptyText && (
          <div className={styles.content}>
            <div className={styles['img-box']}></div>
          </div>
        )}
        {withContent && (
          <div className={styles.content}>
            {props.featuredImageUrl && additionalImages.length === 0 && (
              <div className={styles['img-box']}>
                <img src={props.featuredImageUrl} className={styles.image} />
              </div>
            )}
            {props.featuredImageUrl && additionalImages.length > 0 && (
              <ImagesPreviewGrid
                square
                featuredImageUrl={props.featuredImageUrl}
                imageUrls={additionalImages}
                className={styles['images-grid']}
              />
            )}
            {articleBlock}
            {!props.article && videoUrl && (
              <PostPreviewVideoPlayer videoUrl={videoUrl} />
            )}
          </div>
        )}
      </main>
      <footer className={styles['icons-bsky']}>
        <span>
          <Icon path={mdiCommentOutline} size="20px" />
          {commentsCount && commentsCount > 0 && <div className={styles.comment}>{commentsCount}</div>}
        </span>
        <Icon path={mdiRepeat} size="20px" />
        <Icon path={mdiHeartOutline} size="20px" />
        <Icon path={mdiDotsHorizontal} size="20px" />
      </footer>
    </article>
  )
}
